<template>
  <svg :width="width" :height="height" viewBox="0 0 20 20" fill="none" xmlns="http://www.w3.org/2000/svg">
    <path d="M10.0003 1.66602C12.2105 1.66602 14.3301 2.54399 15.8929 4.10679C17.4557 5.6696 18.3337 7.78921 18.3337 9.99935C18.3337 12.2095 17.4557 14.3291 15.8929 15.8919C14.3301 17.4547 12.2105 18.3327 10.0003 18.3327C7.79019 18.3327 5.67057 17.4547 4.10777 15.8919C2.54497 14.3291 1.66699 12.2095 1.66699 9.99935C1.66699 7.78921 2.54497 5.6696 4.10777 4.10679C5.67057 2.54399 7.79019 1.66602 10.0003 1.66602V1.66602ZM10.0003 3.0549C9.08837 3.0549 8.18534 3.23453 7.3428 3.58352C6.50026 3.93251 5.73471 4.44403 5.08986 5.08889C3.78753 6.39122 3.05588 8.15757 3.05588 9.99935C3.05588 11.666 3.64616 13.1938 4.62533 14.3952L14.3962 4.62435C13.1948 3.64518 11.667 3.0549 10.0003 3.0549ZM10.0003 16.9438C11.8421 16.9438 13.6085 16.2121 14.9108 14.9098C16.2131 13.6075 16.9448 11.8411 16.9448 9.99935C16.9448 8.33268 16.3545 6.8049 15.3753 5.60352L5.60449 15.3743C6.80588 16.3535 8.33366 16.9438 10.0003 16.9438Z" :fill="iconColor"/>
  </svg>
</template>

<script>
export default {
  props: {
    iconName: {
      type: String,
      default: "iconBlockHelper",
    },
    width: {
      type: [Number, String],
      default: 20,
    },
    height: {
      type: [Number, String],
      default: 20,
    },
    iconColor: {
      type: String,
      default: "currentColor",
    },
  },
};
</script>
